import { render } from "./ListGeneric.vue?vue&type=template&id=4bc666ed"
import script from "./ListGeneric.vue?vue&type=script&lang=js"
export * from "./ListGeneric.vue?vue&type=script&lang=js"
script.render = render

export default script